import { useEffect } from 'react';
import triggerAnalyticsEvent from 'syf-js-utilities/helpers/triggerAnalyticsEvent';
import { getCancelPaymentAnalyticsEvent } from '../const/analytics/cancel-payment';
import { getSelectPayAnalyticsEvent } from '../const/analytics/select-pay';
import { getSpendingTrendsAnalyticsEvent } from '../const/analytics/spending-trends';
var analyticsFnMap = {
    cancelPayment: getCancelPaymentAnalyticsEvent,
    selectPay: getSelectPayAnalyticsEvent,
    spendingTrends: getSpendingTrendsAnalyticsEvent
};
var useTriggerAnalyticsEvent = function (featureEvent, promotions, shouldTrigger) {
    if (shouldTrigger === void 0) { shouldTrigger = true; }
    useEffect(function () {
        var _a = featureEvent.split('.'), feature = _a[0], eventName = _a[1];
        if (!shouldTrigger)
            return;
        if (feature === 'cancelPayment') {
            triggerAnalyticsEvent(analyticsFnMap[feature](eventName));
        }
        else if (feature === 'selectPay') {
            triggerAnalyticsEvent(analyticsFnMap[feature](eventName));
        }
        else if (feature === 'spendingTrends') {
            triggerAnalyticsEvent(analyticsFnMap[feature](eventName));
        }
    }, [featureEvent, promotions, shouldTrigger]);
};
export default useTriggerAnalyticsEvent;
//# sourceMappingURL=use-trigger-analytics-event.js.map